<template>
  <div class="wrapper" v-if="userRoles">
    <nav class="main-header navbar navbar-expand navbar-dark navbar-info">
      <ul class="navbar-nav">
        <li class="nav-item"><a data-widget="pushmenu" @click="collapseMenu()" class="nav-link"><i
            class="fas fa-bars"></i></a></li>
      </ul>

      <ul class="navbar-nav ml-auto" v-click-outside="closeEvent">
        <li class="nav-item dropdown" :class="{'show': dropdown}">
          <a id="dropdownSubMenu1" @click="dropdown = !dropdown" data-toggle="dropdown" aria-haspopup="true"
             aria-expanded="false" class="nav-link dropdown-toggle">{{ user.email }}</a>
          <ul aria-labelledby="dropdownSubMenu1" class="dropdown-menu dropdown-menu-right border-0 shadow"
              :class="{'show': dropdown}">
            <li>
              <router-link class="dropdown-item" :to="{ name: 'administrator-profile', params: { id: user.id.uuid }}">
                <b-icon-people class="mr-2"></b-icon-people> Profile
              </router-link>
            </li>
            <li>
              <a @click="logout()" class="dropdown-item">
                <b-icon icon="toggle-off" class="mr-2" aria-hidden="true"></b-icon> Logout
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </nav>
    <aside class="main-sidebar sidebar-dark-blue elevation-4">
      <a href="/vue" class="brand-link bg-info text-center">
        <span class="brand-text font-weight-bold pt-3 pb-3">
          QnM Systems
        </span>
      </a>
      <div class="sidebar">
        <nav class="mt-2">
          <ul data-widget="treeview" role="menu" data-accordion="false"
              class="nav nav-pills nav-sidebar nav-child-indent flex-column">
            <li class="nav-item first">
              <router-link
                  to="/"
                  class="nav-link"
              >
                <b-icon icon="clipboard-data" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.dashboard') }}</p>
              </router-link>
            </li>
            <li id="administration" class="nav-item" :class="{'menu-open': administration}"><a
                class="nav-link " @click="administration = !administration">
              <b-icon icon="shield-check" class="mr-2" aria-hidden="true"></b-icon>
              <p>{{ $t('menu.administration') }}<i class="right fas fa-angle-left"></i></p></a>
              <ul class="nav nav-treeview menu_level_1">
                <li v-remove-element-if-has-no-children="'administration'" class="nav-item">
                  <router-link
                      v-required-roles="['ROLE_BACKOFFICE_USER_GET']"
                      to="/administration/administrator"
                      class="nav-link"
                      :class="[administrator ? 'active router-link-active' : '']"
                  >
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.administration.administrators') }}</p>
                  </router-link>

                  <router-link
                      v-required-roles="['ROLE_BACKOFFICE_GROUP_GET']"
                      to="/administration/groups"
                      class="nav-link"
                  >
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.administration.security_groups') }}</p>
                  </router-link>

                  <router-link
                      v-required-roles="['ROLE_BACKOFFICE_ROLE_GET']"
                      to="/administration/roles"
                      class="nav-link"
                  >
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.administration.security_roles') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="configuration" class="nav-item" :class="{'menu-open': configuration}">
              <a class="nav-link" @click="configuration = !configuration">
                <b-icon-globe class="mr-2"></b-icon-globe>
                <p>{{ $t('menu.configuration') }}<i class="right fas fa-angle-left"></i></p>
              </a>
              <ul v-remove-element-if-has-no-children="'configuration'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_LOCALE_GET']" class="nav-item">
                  <router-link to="/configuration/locale" class="nav-link">
                    <b-icon-flag-fill class="mr-2"></b-icon-flag-fill>
                    <p>{{ $t('menu.configuration.locale') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_BACKOFFICE_CONFIGURATION_GET']" class="nav-item">
                  <router-link to="/configuration-management" class="nav-link">
                    <b-icon-sliders class="mr-2"></b-icon-sliders>
                    <p>{{ $t('menu.configuration.management') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_BACKOFFICE_CONFIGURATION_GET']" class="nav-item">
                  <router-link to="/lobby-filter" class="nav-link">
                    <b-icon-filter-right class="mr-2"></b-icon-filter-right>
                    <p>{{ $t('menu.configuration.lobby') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_CONTENTMANAGEMENT_DICTIONARY_GET']" class="nav-item">
                  <router-link to="/dictionary" class="nav-link">
                    <b-icon-book class="mr-2"></b-icon-book>
                    <p>{{ $t('menu.configuration.dictionary') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_PURCHASE_FUNCOINPACKAGE_GET']" class="nav-item">
                  <router-link to="/fun-coins-packages" class="nav-link">
                    <b-icon-box class="mr-2"></b-icon-box>
                    <p>{{ $t('menu.configuration.funcoins.packages') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_PURCHASE_QUIZCOINPACKAGE_GET']" class="nav-item">
                  <router-link to="/quiz-coins-packages" class="nav-link">
                    <b-icon-box-seam class="mr-2"></b-icon-box-seam>
                    <p>{{ $t('menu.configuration.quizcoins.packages') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_TAG_TAG_GET']" class="nav-item">
                  <router-link to="/configuration/tag" class="nav-link">
                    <b-icon-flag-fill class="mr-2"></b-icon-flag-fill>
                    <p>{{ $t('menu.configuration.tag') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="wallets" class="nav-item" :class="{'menu-open': wallets}">
              <a class="nav-link" @click="wallets = !wallets">
                <b-icon-wallet-fill class="mr-2"></b-icon-wallet-fill>
                <p>{{ $t('menu.wallets') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'wallets'" class="nav nav-treeview menu_level_1">
                <li v-required-roles="['ROLE_WALLET_WALLET_HISTORY_GET']" class="nav-item">
                  <router-link to="/finance/wallet-history" class="nav-link">
                    <b-icon-cash-stack class="mr-2"></b-icon-cash-stack>
                    <p>{{ $t('menu.player_wallets_history') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_WALLET_WALLET_HISTORY_GET']" class="nav-item first">
                  <router-link
                      to="/platform-wallet"
                      class="nav-link"
                  >
                    <b-icon-wallet class="mr-2"></b-icon-wallet>
                    <p>{{ $t('menu.platform_wallets_history') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="transactions" class="nav-item" :class="{'menu-open': transactions}">
              <a class="nav-link" @click="transactions = !transactions">
                <b-icon-cash class="mr-2"></b-icon-cash>
                <p>{{ $t('menu.finance') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'transactions'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_TRANSACTION_TRANSACTION_GET']" class="nav-item">
                  <router-link to="/finance/history" class="nav-link">
                    <b-icon-clock-history class="mr-2"></b-icon-clock-history>
                    <p>{{ $t('menu.finance.transactions_history') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_PURCHASE_INCOMINGMANUALMONEYPAYMENT_GET']" class="nav-item">
                  <router-link to="/finance/incoming-manual-payments" class="nav-link">
                    <b-icon-cash-stack class="mr-2"></b-icon-cash-stack>
                    <p>{{ $t('menu.finance.incoming-manual-payments') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_RESALE_OUTGOINGMANUALMONEYPAYMENT_GET']" class="nav-item">
                  <router-link to="/finance/withdrawals" class="nav-link">
                    <b-icon-cash class="mr-2"></b-icon-cash>
                    <p>{{ $t('menu.finance.withdrawals') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-required-roles="['ROLE_TENANT_TENANT_GET']" class="nav-item first">
              <router-link to="/white-label" class="nav-link">
                <b-icon icon="flag" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.white_label') }}</p>
              </router-link>
            </li>

            <li id="games" class="nav-item" :class="{'menu-open': games}">
              <a class="nav-link" @click="games = !games">
                <b-icon icon="display" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.games') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'games'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_LOBBY_WAITINGROOM_GET']" class="nav-item">
                  <router-link to="/waiting-room" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.games.waiting_rooms') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_GAME_GAMEHISTORYITEM_GET']" class="nav-item">
                  <router-link to="/active-game" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.games.active_game') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_GAME_GAMEHISTORYITEM_GET']" class="nav-item">
                  <router-link to="/game-result" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.games.game_results') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="tournament" class="nav-item" :class="{'menu-open': tournament}">
              <a class="nav-link" @click="tournament = !tournament">
                <b-icon icon="trophy-fill" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.tournament') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'tournament'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_LOBBY_WAITINGROOM_GET']" class="nav-item">
                  <router-link to="/tournament" class="nav-link">
                    <b-icon icon="trophy-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.tournament.waiting_rooms') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_GAME_GAMEHISTORYITEM_GET']" class="nav-item">
                  <router-link to="/active-tournament-game" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.games.active_tournament_game') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_GAME_GAMEHISTORYITEM_GET']" class="nav-item">
                  <router-link to="/game-result-tournament" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.games.game_results_tournament') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_GAME_GAMEHISTORYITEM_GET']" class="nav-item">
                  <router-link to="/instant-tournament-history-module" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.tournament.instant_tournament_history') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="scheduledTournament" class="nav-item" :class="{'menu-open': scheduledTournament}">
              <a class="nav-link" @click="scheduledTournament = !scheduledTournament">
                <b-icon icon="trophy-fill" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.scheduled_tournament') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'scheduledTournament'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_LOBBY_WAITINGROOM_GET']" class="nav-item">
                  <router-link to="/scheduled-tournament" class="nav-link">
                    <b-icon icon="trophy-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.scheduled_tournament.waiting_rooms') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_LOBBY_WAITINGROOM_GET']" class="nav-item">
                  <router-link to="/scheduled-tournament-calendar" class="nav-link">
                    <b-icon icon="trophy-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.scheduled_tournament_calendar') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="questions" class="nav-item" :class="{'menu-open': questions}">
              <a class="nav-link " @click="questions = !questions">
                <b-icon icon="patch-question-fill" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.questions') }} <i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'questions'" class="nav nav-treeview menu_level_1">

                <li v-required-roles="['ROLE_QUESTION_QUESTION_GET']" class="nav-item">
                  <router-link to="/question" class="nav-link">
                    <b-icon icon="patch-question-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.questions.question_list') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_QUESTION_QUESTIONCATEGORY_GET']" class="nav-item">
                  <router-link to="/question-category" class="nav-link">
                    <b-icon icon="question-diamond" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.questions.question_category') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_QUESTION_QUESTIONIMPORT_GET']" class="nav-item">
                  <router-link to="/question-import" class="nav-link">
                    <b-icon icon="question-diamond" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.questions.question_import') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_QUESTION_QUESTIONCATEGORY_GET']" class="nav-item">
                  <router-link to="/reported-errors" class="nav-link">
                    <b-icon icon="question-diamond" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.questions.reported_errors') }}</p>
                    <div class="player-online-dot-container d-flex align-items-center ml-2">
                      <div v-if="isQuestionToVerifyError" class="player-online-dot"></div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </li>

            <li v-required-roles="['ROLE_BONUS_BONUSDEFINITION_GETLIST']" class="nav-item first">
              <router-link to="/bonus-definition" class="nav-link">
                <b-icon icon="flag" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.bonus_definition') }}</p>
              </router-link>
            </li>

            <li v-required-roles="['ROLE_CONTENTMANAGEMENT_RESOURCE_GET']" class="nav-item first">
              <router-link to="/cms" class="nav-link" :class="[cms ? 'active router-link-active' : '']">
                <b-icon icon="file-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.cms') }}</p>
              </router-link>
            </li>

            <li v-required-roles="['ROLE_LABELTRANSLATION']" class="nav-item first">
              <router-link to="/translations" class="nav-link">
                <b-icon icon="flag" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.translations') }}</p>
              </router-link>
            </li>

            <li id="playerDetails" class="nav-item" :class="{'menu-open': playerDetails}">
              <a class="nav-link " @click="playerDetails = !playerDetails">
                <b-icon icon="patch-question-fill" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.players') }} <i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'playerDetails'" class="nav nav-treeview menu_level_1">
                <li v-required-roles="['ROLE_CLIENTSECURITY_PLAYER_GETLIST']" class="nav-item">
                  <router-link to="/players" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.player_list') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_CLIENTSECURITY_PLAYER_GETLIST']" class="nav-item">
                  <router-link to="/players-kyc" class="nav-link">
                    <b-icon icon="people" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.kyc') }}</p>
                    <div class="player-online-dot-container d-flex align-items-center ml-2">
                      <div v-if="isUserWithPendingKycStatus" class="player-online-dot"></div>
                    </div>
                  </router-link>
                </li>
              </ul>
            </li>

            <li id="crm" class="nav-item" :class="{'menu-open': crm}">
              <a class="nav-link" @click="crm = !crm">
                <b-icon icon="display" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.crm') }}<i class="right fas fa-angle-left"></i></p>
              </a>

              <ul v-remove-element-if-has-no-children="'crm'" class="nav nav-treeview menu_level_1">
                <li v-required-roles="['ROLE_CLIENTSECURITY_PLAYERSTATISTICS_GET']" class="nav-item">
                  <router-link to="/crm-dashboard-module" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.crm_dashboard') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_CLIENTSECURITY_PLAYER_EXPORT']" class="nav-item">
                  <router-link to="/player-export" class="nav-link">
                    <b-icon icon="people-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.player_export') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_SEGMENT_GETSEGMENTSACTION']" class="nav-item first">
                  <router-link to="/user-segment" class="nav-link" :class="[userSegment ? 'active router-link-active' : '']">
                    <b-icon icon="file-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.user_segment') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_INBOX_NOTIFICATION_GETNOTIFICATIONS']" class="nav-item first">
                  <router-link to="/user-notification" class="nav-link" :class="[userNotification ? 'active router-link-active' : '']">
                    <b-icon icon="file-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.user_notification') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_INBOX_CAMPAIGN_GETCAMPAIGNS']" class="nav-item first">
                  <router-link to="/user-campaign" class="nav-link" :class="[userCampaign ? 'active router-link-active' : '']">
                    <b-icon icon="file-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.user_campaign') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_INBOX_INBOX_GETTHREADSTOPLAYERS']" class="nav-item first">
                  <router-link to="/mail-box" class="nav-link" :class="[mailBox ? 'active router-link-active' : '']">
                    <b-icon icon="file-text-fill" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.mail_box') }}</p>
                  </router-link>
                </li>

                <li v-required-roles="['ROLE_BACKOFFICE_REPORT_GET']" class="nav-item first">
                  <router-link to="/reports" class="nav-link" :class="[reports ? 'active router-link-active' : '']">
                    <b-icon icon="flag" class="mr-2" aria-hidden="true"></b-icon>
                    <p>{{ $t('menu.reports') }}</p>
                  </router-link>
                </li>
              </ul>
            </li>
            <li v-required-roles="['ROLE_REPORT_GETGAMEREPORT']" class="nav-item first">
              <router-link to="/statistics" class="nav-link" :class="[statistics ? 'active router-link-active' : '']">
                <b-icon icon="flag" class="mr-2" aria-hidden="true"></b-icon>
                <p>{{ $t('menu.statistics') }}</p>
              </router-link>
            </li>
          </ul>
        </nav>
      </div>
    </aside>
    <div class="content-wrapper">
      <div class="content">
        <div class="container-fluid">
          <router-view/>
        </div>
      </div>
    </div>
    <footer class="main-footer">
      <strong>Copyright © 2022 QnM Systems</strong>
    </footer>
    <aside class="control-sidebar control-sidebar-dark advanced-filters"></aside>
    <div id="sidebar-overlay"></div>
  </div>
</template>

<script>
import {mapState} from "vuex";

export default {
  components: {},
  data() {
    return {
      administration: false,
      administrator: false,
      configuration: false,
      transactions: false,
      wallets: false,
      questions: false,
      userSegment: false,
      playerDetails: false,
      crm: false,
      games: false,
      tournament: false,
      scheduledTournament: false,
      scheduledTournamentCalendar: false,
      dropdown: false,
      bonusDefinition: false,
      playerExport: false,
      mailBox: false,
      userNotification: false,
      cms: false,
      whiteLabel: false,
      userCampaign: false,
      crmDashboard: false,
      reports: false,
      statistics: false
    }
  },
  mounted() {

    if (!this.user) {
      this.$store.dispatch('root/fetchUser');
      this.$store.dispatch('root/fetchUserRoles');
      
    }
    this.closeDropDownBeforeRouterChange();
    this.$store.dispatch('root/getLocale');
    this.$store.dispatch('root/getTenant');
    this.$store.dispatch('root/getDictionary', 'sex');
    this.$store.dispatch('root/getDictionary', 'country');
    this.$store.dispatch('root/checkNumberOfPlayersWithKycPendingStatus');
    this.$store.dispatch('root/checkNumberOfQuestionsToVerifyError');
    this.checkRoute(this.$route);
  },
  computed: {
    ...mapState({
      isUserWithPendingKycStatus: state => state.root.isUserWithPendingKycStatus,
      isQuestionToVerifyError: state => state.root.isQuestionToVerifyError
    }),
    user: function () {
      return this.$store.getters["root/user"];
    },
    userRoles: function () {
      return this.$store.getters["root/userRoles"];
    }
  },
  methods: {
    closeDropDownBeforeRouterChange() {
      this.$router.beforeEach((to, from, next) => {
        this.dropdown = false;
        next();
      })
    },
    collapseMenu() {
      const body = document.querySelector('body');
      body.classList.toggle('sidebar-collapse')
    },
    closeEvent: function () {
      this.dropdown = false;
    },
    checkRoute(route) {
      this.closeAll();
      switch (route.name) {
        case 'waiting-room-list': {
          this.games = true;
          break;
        }
        case 'active-game': {
          this.games = true;
          break;
        }
        case 'game-result-list': {
          this.games = true;
          break;
        }
        case 'reported-errors': {
          this.questions = true;
          break;
        }
        case 'question-list': {
          this.questions = true;
          break;
        }
        case 'question-category-list': {
          this.questions = true;
          break;
        }
        case 'question-import': {
          this.questions = true;
          break;
        }
        case 'administrator': {
          this.administration = true;
          this.administrator = true;
          break;
        }
        case 'administrator-profile': {
          this.administration = true;
          this.administrator = true;
          break;
        }
        case 'administrator-security': {
          this.administration = true;
          this.administrator = true;
          break;
        }
        case 'security-group': {
          this.administration = true;
          break;
        }
        case 'security-role': {
          this.administration = true;
          break;
        }
        case 'configuration-management': {
          this.configuration = true;
          break;
        }
        case 'dictionary-list': {
          this.configuration = true;
          break;
        }
        case 'quiz-coins-package': {
          this.configuration = true;
          break;
        }
        case 'coins-package': {
          this.configuration = true;
          break;
        }
        case 'dictionary-entry': {
          this.configuration = true;
          break;
        }
        case 'locale-list': {
          this.configuration = true;
          break;
        }
        case 'lobby-filter': {
          this.configuration = true;
          break;
        }
        case 'tag-list': {
          this.configuration = true;
          break;
        }
        case 'players-kyc': {
          this.playerDetails = true;
          break;
        }
        case 'player-list': {
          this.playerDetails = true;
          break;
        }
        case 'player-details': {
          this.playerDetails = true;
          break;
        }
        case 'player-kyc': {
          this.playerDetails = true;
          break;
        }
        case 'player-wallets': {
          this.playerDetails = true;
          break;
        }
        case 'player-transactions': {
          this.playerDetails = true;
          break;
        }
        case 'player-game-history': {
          this.playerDetails = true;
          break;
        }
        case 'player-login-history': {
          this.playerDetails = true;
          break;
        }
        case 'player-notes': {
          this.playerDetails = true;
          break;
        }
        case 'incoming-manual-payments': {
          this.transactions = true;
          break;
        }
        case 'transactions-history': {
          this.transactions = true;
          break;
        }
        case 'withdrawals': {
          this.transactions = true;
          break;
        }
        case 'wallet-history': {
          this.wallets = true;
          break;
        }
        case 'platform-wallet': {
          this.wallets = true;
          break;
        }
        case 'resources-list': {
          this.cms = true;
          break;
        }
        case 'bonus-definition': {
          this.bonusDefinition = true;
          break;
        }
        case 'cms-general-create': {
          this.cms = true;
          break;
        }
        case 'cms-content-create': {
          this.cms = true;
          break;
        }
        case 'cms-advanced-create': {
          this.cms = true;
          break;
        }
        case 'cms-translations-create': {
          this.cms = true;
          break;
        }
        case 'cms-child-elements-create': {
          this.cms = true;
          break;
        }
        case 'cms-attributes': {
          this.cms = true;
          break;
        }
        case 'cms-general': {
          this.cms = true;
          break;
        }
        case 'cms-content': {
          this.cms = true;
          break;
        }
        case 'cms-advanced': {
          this.cms = true;
          break;
        }
        case 'cms-translations': {
          this.cms = true;
          break;
        }
        case 'cms-child-elements': {
          this.cms = true;
          break;
        }
        case 'user-segment': {
          this.userSegment = true;
          break;
        }
        case 'user-segment-list': {
          this.userSegment = true;
          break;
        }
        case 'user-segment-players': {
          this.userSegment = true;
          break;
        }
        case 'player-export': {
          this.playerExport = true;
          this.crm = true;
          break;
        }
        case 'mail-box': {
          this.mailBox = true;
          break;
        }
        case 'user-notification-list': {
          this.userNotification = true;
          break;
        }
        case 'user-notification-create': {
          this.userNotification = true;
          break;
        }
        case 'white-label': {
          this.whiteLabel = true;
          break;
        }
        case 'user-campaign-list': {
          this.userCampaign = true;
          break;
        }
        case 'user-campaign-create': {
          this.userCampaign = true;
          break;
        }
        case 'crm-dashboard': {
          this.crmDashboard = true;
          break;
        }
        case 'quick-summary': {
          this.reports = true;
          break;
        }
        case 'affiliate-quick-summary': {
          this.reports = true;
          break;
        }
        case 'management': {
          this.reports = true;
          break;
        }
        case 'marketing': {
          this.reports = true;
          break;
        }
        case 'profile-countries': {
          this.reports = true;
          break;
        }
        case 'profile-countries-details': {
          this.reports = true;
          break;
        }
        case 'game': {
          this.statistics = true;
          break;
        }
        case 'question': {
          this.statistics = true;
          break;
        }
        case 'player': {
          this.statistics = true;
          break;
        }
        case 'financial': {
          this.statistics = true;
          break;
        }
      }
    },
    closeAll() {
      this.games = false;
      this.questions = false;
      this.configuration = false;
      this.administration = false;
      this.administrator = false;
      this.playerDetails = false;
      this.transactions = false;
      this.wallets = false;
      this.cms = false;
      this.userSegment = false;
      this.bonusDefinition = false;
      this.playerExport = false;
      this.mailBox = false;
      this.userNotification = false;
      this.whiteLabel = false;
      this.userCampaign = false;
      this.crmDashboard = false;
      this.statistics = false;
      this.reports = false;
    },
    logout() {
      this.$store.dispatch('root/logout').then(() => {
        this.$router.push({name: 'login'})
      })
    }
  },
  watch: {
    $route() {
      this.checkRoute(this.$route);
    }
  },
  events: {

  }
}
</script>
